import React, { useState } from "react"
import { Formik, Form, FieldArray, ErrorMessage } from "formik";
import { useSearchParams, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import "../share/form.css";
import { FaSistrix } from "react-icons/fa";
import Swal from "sweetalert2";
import TextErrors from "../share/TextErrors";
import { Loading } from "../share/loading";
import { useEffect } from "react";
import { Container, Input, Table } from "reactstrap";
export function CreateAttatchFileFormTestComponent() {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    let borrowId = searchParams.get("req");
    let train = searchParams.get("train");
    let test = searchParams.get("test");
    let status = searchParams.get("status");
    const user = JSON.parse(localStorage.getItem("userData"));
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        async function getData() {
            setLoading(true)
            let postData = new FormData();
            postData.append("borrowId", borrowId);
            try {
                let res = await fetch("api/Borrow/testTimeForAttatchFile", {
                    method: "POST",
                    body: postData
                })
                let resJson = await res.json();
                setData(resJson.dataenum);
            } catch (e) {
                // console.log("err =>", e)
            } finally {
                setLoading(false);
            }
        }
        getData();
    }, [])

    const initialValues = {
        roldId: user.roldId,
        fileInputAr: data.map((item) => ({
            fMapPathView: item?.fMapPathView ?? null,
            id: item.testTimeId,
            fMapPath: ""
        })),

        files: ""
    }
    const validateSchema = Yup.object().shape({
        fileInputAr: Yup.array().of(
            Yup.object().shape({
                fMapPathView: Yup.string().nullable(),
                fMapPath: Yup.mixed().when('fMapPathView', {
                    is: null,
                    then: Yup.mixed().required("กรุณาแนบไฟล์").test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg ', (value) => {
                        return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type)
                    }).test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 2MB', (value) => {
                        const maxSize = 2000000;
                        return !value || (value.size <= maxSize);
                    })
                }),

            })
        )
    });

    const onSubmit = async (values) => {

        let postData = new FormData();
        let file = [];
        let id = [];
        values.fileInputAr.forEach((item) => {
            if (item.fMapPath !== "") {
                file.push(item.fMapPath)
                id.push(item.id)
            }
        })
        file.forEach(file => {
            postData.append("files", file, file.name);
        })
        id.forEach(item => {
            postData.append("id", item)
        })

        let notAttatchFile = file.every(str => str === "");
        if (notAttatchFile) {
            return navigate(`/borrowing/BorrowForm/testJob?req=${borrowId}&train=${train}&test=${test}&status=${status}`);
        } else {
            try {
                let res = await fetch("api/BorrowRegis/saveFileTest", {
                    method: "POST",
                    body: postData
                })
                let resJson = await res.json();

                if (resJson.status === 1) {
                    Swal.fire({
                        icon: "success",
                        title: "บันทึกข้อมูลสำเร็จ",
                        text: "บันทึกข้อมูลต่อหรือไม่ ?",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            return navigate(`/borrowing/BorrowForm/testJob?req=${borrowId}&train=${train}&test=${test}&status=${status}`);
                        } else {
                            navigate("/borrowing/");
                        }
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "บันทึกข้อมูลไม่สำเร็จ",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        text: `เนื่องจาก ${resJson.message}`,
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    });
                }
            } catch (e) {
                // console.log(e)
            } finally {
                setLoading(false)
            }
        }


    };

    const checkPreviousPage = () => {
        return navigate(`/borrowing/BorrowForm/testDetail?req=${borrowId}&train=${train}&test=${test}&status=${status}`)
    }



    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    function onClickUrl(url) {
        return () => openInNewTab(url)
    }

    if (loading) { return <Loading /> }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validateSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {({ values, setFieldValue, handleChange, errors, handleBlur }) => {
                return (

                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">

                        <Form autoComplete="off" className="w-75">
                            <ErrorMessage name={`files`} component={TextErrors} />
                            <Table className="styled-table mt-3 w-100" striped bordered hover>
                                <tr className="text-white text-center w-100" style={{ lineHeight: "3rem", backgroundColor: "#0A66C2" }}>
                                    <th>ลำดับ</th>
                                    <th>ชื่อสาขาอาชีพ</th>
                                    <th>ครั้งที่ดำเนินการทดสอบ</th>
                                    <th>แนบไฟล์</th>
                                </tr>

                                <FieldArray name="fileInputAr">
                                    {(FieldArrayProps) => {
                                        return (
                                            <>
                                                {data.map((item, index) => (
                                                    <tr key={index} className="text-center">
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <div className="d-flex justify-content-center align-items-center">
                                                                {item.lawOccupationName}
                                                            </div>

                                                        </td>
                                                        <td>
                                                            <div className="d-flex justify-content-center align-items-center">
                                                                {item.timeId}
                                                            </div>

                                                        </td>
                                                        <td className="">
                                                            <div className="d-flex justify-content-center align-items-center">
                                                                <Input
                                                                    name={`fileInputAr[${index}].fMapPath`}
                                                                    type="file"
                                                                    onBlur={handleBlur}
                                                                    onChange={(e) => {
                                                                        handleChange(e, index)
                                                                        if (e.target && e.target.files[0]) {
                                                                            // setFileInput((prev) => [...prev,e.target.files[0]])
                                                                            setFieldValue(`fileInputAr[${index}].fMapPath`, e.target.files[0]);
                                                                        }
                                                                    }}
                                                                    className="w-50 input-color rounded-pill"
                                                                // value={undefined}   
                                                                />
                                                                {item.fMapPathView !== null ? (
                                                                    <FaSistrix
                                                                        className="mx-3 style-icon"
                                                                        onClick={onClickUrl(`${item.fMapPathView}`)}
                                                                    />
                                                                ) : null}
                                                                <ErrorMessage name={`fileInputAr[${index}].fMapPath`} component={TextErrors} />

                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </>
                                        )
                                    }}
                                </FieldArray>
                            </Table>
                            <div className="d-flex justify-content-between align-items-center mt-5">
                                <button
                                    type="button"
                                    className="btn-blue p-2 w-25"
                                    onClick={checkPreviousPage}
                                >
                                    ย้อนกลับ
                                </button>
                                <button className="btn-blue p-2 w-25" type="submit">ถัดไป</button>


                            </div>

                        </Form>

                    </Container>

                )
            }}




        </Formik>
    )
}